import axiosClient from '@/axios/axiosClient';
import { ref } from 'vue';
import { carData } from '@/types';
import axios from 'axios';

export function useParser() {
  async function parseLink(link: string, auction: string) {
    const { data } = await axiosClient.post('/parse', {
      link_for_parse: link,
      auction,
    });

    return data;
  }

  async function getCurrencyCourse() {
    return (await axiosClient.get('/getCours')).data;
  }
  async function getCustomClearance(type: string, data: carData) {
    switch (type) {
      case 'poland':
        return calcPolandCustomClearance(data);
      case 'george':
        return (await calcGeorgeCustomClearance(data)) ?? 0;
      case 'ukraine':
        return await calcUkraineCustomClearance(data);
    }
  }

  function calcPolandCustomClearance(data: carData): number {
    const firstPath =
      (data.info.priceNow + data.info.auctionFee + data.shipping.cost) * 0.31;
    return +firstPath.toFixed(2) ?? 0;
  }
  async function calcGeorgeCustomClearance(data: carData) {
    const responseClearance = await axiosClient.post('get-ge-tax', {
      cap: parseFloat(data.info.eng),
      year: data.info.yearBorn,
      type: data.info.typeEng.toLowerCase(),
    });

    if (responseClearance.status === 200) {
      const jsonResponse = JSON.parse(responseClearance.data);

      return Math.floor(+jsonResponse.sum / 2.77) ?? 0;
    }
  }
  async function calcUkraineCustomClearance(data: carData) {
    const response = await axiosClient.post('/getNalog', {
      AccCapacity: +data.info.eng,
      eng: data.info.eng,
      price: +data.info.priceNow + +data.info.auctionFee + 1600,
      typeEng: data.info.typeEng,
      year: data.info.yearBorn,
    });

    return +response.data.nalog.total ?? 0;
  }

  return {
    parseLink,
    getCustomClearance,
    getCurrencyCourse,
  };
}
